module.exports = __webpack_public_path__ + "static/img/OOSH_044.8e92197.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_044.jpg
// module id = 6gtE
// module chunks = 170